import React from 'react';
import FormFieldInput, { FormFieldInputConfig } from './form-field-input';
import { getFieldProperties } from './helpers';

/**
 * The label is driven by the display name in the db, which doesn't allow text long enough to store the consent text in the label.
 * So, to prevent users from manually overriding and to set the text correctly, we manually override here.
 */
export const CONSENT_TEXT =
  'I agree that the practice may send me Patient Care Related Messaging at the number I provided above. I understand my consent is not required for purchase. Messages Frequency will vary. Msg & data rates may apply. Reply HELP for help or STOP to cancel.';

export const MobileConsentValidationMessage =
  'Please select the mobile consent checkbox';

export type FormFieldMobileConsentProps = {
  field: FormFieldInputConfig;
  isRenderedField: boolean;
  onChange: Function;
  value: string;
  validationMessage: unknown[] | string;
  readOnly: boolean;
};

export const FormFieldMobileConsent: React.FC<FormFieldMobileConsentProps> = (
  props
) => {
  const {
    field,
    isRenderedField,
    onChange,
    value,
    validationMessage,
    readOnly
  } = props;

  const { common: properties } = getFieldProperties(field, ['common']) as {
    common: Map<string, unknown>;
  };

  const isChecked = value === 'true' || Boolean(value);

  const handleCheckboxChange = (event: any, group: any) => {
    const newValue: boolean = event.target.checked;
    event.target.value = newValue;
    onChange(event, group, newValue);
  };

  const inputOptions: Record<string, unknown> = {
    isRenderedField,
    readOnly,
    validationMessage,
    properties: { ...properties, hideLabel: true, multiple: true },
    label: CONSENT_TEXT,
    onChange: handleCheckboxChange,
    value: isChecked,
    checked: isChecked,
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexFlow: 'row wrap',
          alignContent: 'center'
        }}
      >
        <FormFieldInput field={field} options={inputOptions} />
      </div>
    </div>
  );
};

export default FormFieldMobileConsent;
